import React from "react";
import PropTypes from 'prop-types';

const X = props => (
  <svg width={props.width} height={props.height} className={props.className} viewBox="0 0 14 14">
    <g fill="none" fillRule="evenodd" stroke={props.stroke} strokeLinecap="square" strokeWidth="1.846" transform="translate(1 1)">
      <path d="M0.461538462,0.461538462 L11.5768565,11.5768565"/>
      <path d="M0.461538462,0.461538462 L11.5768565,11.5768565" transform="matrix(-1 0 0 1 12 0)"/>
    </g>
  </svg>
);

X.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
  stroke: PropTypes.string,
}

X.defaultProps = {
  width: 14,
  height: 14,
  className: "",
  stroke: '#FFFFFF',
}

export default X;



// WEBPACK FOOTER //
// ./src/components/svgs/X.js